import { supabase } from './supabase'

export const WORK_UNITS = [
  { key: 'loja-central', label: 'Loja Central', climate: true },
  { key: 'facil-aero-rancho', label: 'Fácil Aero Rancho', climate: true },
  { key: 'facil-guaicurus', label: 'Fácil Guaicurus', climate: true },
  { key: 'facil-cel-antonino', label: 'Fácil Cel. Antonino', climate: true },
  { key: 'facil-bosque', label: 'Fácil Bosque', climate: true },
  { key: 'loja-moreninha', label: 'Loja Moreninha', climate: true },
  { key: 'call-center', label: 'Call Center', climate: true },
  { key: 'outro', label: 'Outro', climate: false },
] as const

export type WorkUnitKey = typeof WORK_UNITS[number]['key']

export type DailyWorkContext = {
  work_date: string
  unit_key: WorkUnitKey
  climate_score: number | null
}

export type ClimateIntelligence = {
  period_days: number
  summary: {
    responses_today: number
    responses_period: number
    average_score: number
    positive_pct: number
    negative_pct: number
  }
  units: Array<{
    unit_key: string
    unit_label: string
    responses: number
    average_score: number
    positive_pct: number
    negative_pct: number
  }>
  distribution: {
    score_1: number
    score_2: number
    score_3: number
    score_4: number
    score_5: number
  }
  daily: Array<{
    date: string
    responses: number
    average_score: number
  }>
}

export function requiresClimate(unitKey: string) {
  return WORK_UNITS.some((unit) => unit.key === unitKey && unit.climate)
}

export async function loadDailyWorkContext(): Promise<DailyWorkContext | null> {
  const { data, error } = await supabase.rpc('get_daily_work_context')
  if (error) throw error
  return (data ?? null) as DailyWorkContext | null
}

export async function saveDailyWorkContext(unitKey: WorkUnitKey, climateScore: number | null) {
  const { data, error } = await supabase.rpc('save_daily_work_context', {
    p_unit_key: unitKey,
    p_climate_score: climateScore,
  })
  if (error) throw error
  return data as DailyWorkContext
}

export async function loadClimateIntelligence(days: number): Promise<ClimateIntelligence> {
  const { data, error } = await supabase.rpc('climate_intelligence', { p_days: days })
  if (error) throw error
  return data as ClimateIntelligence
}
